"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingTextVfxStepArgs = void 0;
const uuid_1 = require("uuid");
const DamageTypeToColor_1 = require("../../maps/DamageTypeToColor");
const LocationSelector_1 = require("../LocationSelector");
class FloatingTextVfxStepArgs {
    constructor(text, location, color = "black", size = "medium", family = "roboto", direction = "up", speed = "medium") {
        this.text = text;
        this.location = location;
        this.color = color;
        this.size = size;
        this.family = family;
        this.direction = direction;
        this.speed = speed;
        this.__typeName = "FloatingText";
        this.id = (0, uuid_1.v4)();
    }
}
exports.FloatingTextVfxStepArgs = FloatingTextVfxStepArgs;
FloatingTextVfxStepArgs.fromDamage = (targetId, damage, crit, attachment = "head") => new FloatingTextVfxStepArgs(`${damage.amount === 0 ? "" : "-"}${damage.amount}`, new LocationSelector_1.ActorVfxLocationSelector(targetId, attachment), DamageTypeToColor_1.DamageTypeToColor[damage.type], crit ? "large" : "small");
FloatingTextVfxStepArgs.fromHealing = (targetId, amount, crit) => new FloatingTextVfxStepArgs(`${amount === 0 ? "" : "+"}${amount}`, new LocationSelector_1.ActorVfxLocationSelector(targetId, "head"), "green", crit ? "large" : "small");
